export function defineImageStyle(config) {
  return config;
}
